<div class="ns-page">

  <!-- Header identical to notification-settings -->
  <div class="ns-header">
    <div class="ns-header__title">
      <i class="fa fa-sliders" style="color: #2e5ea8;"></i>
      <div>
        <h2 class="text-xl font-bold text-slate-800 tracking-tight mb-1">Selects Data List</h2>
        <p class="text-xs text-muted mb-0">Configure dynamic dropdown options and system catalogs for orders, clients, and user roles.</p>
      </div>
    </div>
    <div class="ns-header__actions">
      <button type="button" class="ns-btn-secondary" (click)="expandAll()">
        <i class="fa fa-expand"></i> Expand All
      </button>
      <button type="button" class="ns-btn-secondary" (click)="collapseAll()">
        <i class="fa fa-compress"></i> Collapse All
      </button>
    </div>
  </div>

  <!-- Main Accordion Stack -->
  <div class="ns-accordions">

    <!-- ==========================================
         SECTION 1: TERRITORY & GEOGRAPHY
         ========================================== -->
    <div class="ns-section-divider">
      <i class="fa fa-globe"></i>
      <span>Territory & Geography</span>
    </div>

    <!-- 1.1 AREAS -->
    <div class="ns-accordion-item" [class.ns-accordion-item--expanded]="isExpanded('areas')">
      <div class="ns-accordion-header" (click)="toggleSection('areas')">
        <div class="ns-accordion-header__title-group">
          <span class="ns-accordion-header__title">Areas</span>
          <span class="ns-count-badge">{{ zonessel.length }}</span>
        </div>
        <i class="fa fa-chevron-down ns-accordion-header__arrow"
           [class.ns-accordion-header__arrow--expanded]="isExpanded('areas')"></i>
      </div>

      <div class="ns-accordion-body" [class.ns-accordion-body--expanded]="isExpanded('areas')">
        <div class="ns-accordion-content">
          <!-- Form -->
          <div class="ns-form-wrapper">
            <form [formGroup]="zoneSelForm" (ngSubmit)="newZoneSel()" autocomplete="off">
              <div class="ns-input-row">
                <div class="ns-input-container">
                  <input
                    type="text"
                    class="ns-input"
                    placeholder="Enter new area name..."
                    formControlName="name"
                    [class.is-invalid]="zoneNameNoValido"
                    toUppercase
                  />
                </div>
                <button type="submit" class="ns-btn-primary" [disabled]="loadingZone || zoneSelForm.invalid">
                  <i class="fa fa-plus"></i> Add Area
                </button>
              </div>
              <small *ngIf="zoneNameNoValido" class="ns-error-msg">* Required</small>
            </form>
          </div>

          <!-- Table -->
          <div class="ns-table-wrapper">
            <table class="ns-table">
              <thead>
                <tr>
                  <th class="col-index">#</th>
                  <th>Area Name</th>
                  <th class="col-action">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of zonessel; let i = index" [class.row-alt]="i % 2 === 0">
                  <td class="col-index">{{ i + 1 }}</td>
                  <td class="col-name">{{ item.name | titlecase }}</td>
                  <td class="col-action">
                    <button
                      type="button"
                      class="ns-btn-delete"
                      (click)="deleteZoneSel(item)"
                      title="Delete Area">
                      <i class="fa fa-trash-o"></i>
                    </button>
                  </td>
                </tr>
                <tr *ngIf="zonessel.length === 0 && !loadingZone">
                  <td colspan="3" class="ns-status-cell ns-status-cell--empty">
                    <i class="fa fa-folder-open-o"></i> No areas registered yet
                  </td>
                </tr>
                <tr *ngIf="loadingZone">
                  <td colspan="3" class="ns-status-cell">
                    <i class="fa fa-spinner fa-spin"></i> Loading areas...
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- 1.2 STATES -->
    <div class="ns-accordion-item" [class.ns-accordion-item--expanded]="isExpanded('states')">
      <div class="ns-accordion-header" (click)="toggleSection('states')">
        <div class="ns-accordion-header__title-group">
          <span class="ns-accordion-header__title">States</span>
          <span class="ns-count-badge">{{ statessel.length }}</span>
        </div>
        <i class="fa fa-chevron-down ns-accordion-header__arrow"
           [class.ns-accordion-header__arrow--expanded]="isExpanded('states')"></i>
      </div>

      <div class="ns-accordion-body" [class.ns-accordion-body--expanded]="isExpanded('states')">
        <div class="ns-accordion-content">
          <!-- Form -->
          <div class="ns-form-wrapper">
            <form [formGroup]="stateSelForm" (ngSubmit)="newStateSel()" autocomplete="off">
              <div class="ns-input-row">
                <div class="ns-input-container">
                  <input
                    type="text"
                    class="ns-input"
                    placeholder="Enter new state name..."
                    formControlName="name"
                    [class.is-invalid]="stateNameNoValido"
                    toUppercase
                  />
                </div>
                <button type="submit" class="ns-btn-primary" [disabled]="loadingState || stateSelForm.invalid">
                  <i class="fa fa-plus"></i> Add State
                </button>
              </div>
              <small *ngIf="stateNameNoValido" class="ns-error-msg">* Required</small>
            </form>
          </div>

          <!-- Table -->
          <div class="ns-table-wrapper">
            <table class="ns-table">
              <thead>
                <tr>
                  <th class="col-index">#</th>
                  <th>State Name</th>
                  <th class="col-action">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of statessel; let i = index" [class.row-alt]="i % 2 === 0">
                  <td class="col-index">{{ i + 1 }}</td>
                  <td class="col-name">{{ item.name | titlecase }}</td>
                  <td class="col-action">
                    <button
                      type="button"
                      class="ns-btn-delete"
                      (click)="deleteStateSel(item)"
                      title="Delete State">
                      <i class="fa fa-trash-o"></i>
                    </button>
                  </td>
                </tr>
                <tr *ngIf="statessel.length === 0 && !loadingState">
                  <td colspan="3" class="ns-status-cell ns-status-cell--empty">
                    <i class="fa fa-folder-open-o"></i> No states registered yet
                  </td>
                </tr>
                <tr *ngIf="loadingState">
                  <td colspan="3" class="ns-status-cell">
                    <i class="fa fa-spinner fa-spin"></i> Loading states...
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- 1.3 CITIES -->
    <div class="ns-accordion-item" [class.ns-accordion-item--expanded]="isExpanded('cities')">
      <div class="ns-accordion-header" (click)="toggleSection('cities')">
        <div class="ns-accordion-header__title-group">
          <span class="ns-accordion-header__title">Cities</span>
          <span class="ns-count-badge">{{ citysel.length }}</span>
        </div>
        <i class="fa fa-chevron-down ns-accordion-header__arrow"
           [class.ns-accordion-header__arrow--expanded]="isExpanded('cities')"></i>
      </div>

      <div class="ns-accordion-body" [class.ns-accordion-body--expanded]="isExpanded('cities')">
        <div class="ns-accordion-content">
          <!-- Form -->
          <div class="ns-form-wrapper">
            <form [formGroup]="citySelForm" (ngSubmit)="newCitySel()" autocomplete="off">
              <div class="ns-input-row">
                <div class="ns-input-container">
                  <input
                    type="text"
                    class="ns-input"
                    placeholder="Enter new city name..."
                    formControlName="name"
                    [class.is-invalid]="cityNameNoValido"
                    toUppercase
                  />
                </div>
                <button type="submit" class="ns-btn-primary" [disabled]="loadingCity || citySelForm.invalid">
                  <i class="fa fa-plus"></i> Add City
                </button>
              </div>
              <small *ngIf="cityNameNoValido" class="ns-error-msg">* Required</small>
            </form>
          </div>

          <!-- Table -->
          <div class="ns-table-wrapper">
            <table class="ns-table">
              <thead>
                <tr>
                  <th class="col-index">#</th>
                  <th>City Name</th>
                  <th class="col-action">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of citysel; let i = index" [class.row-alt]="i % 2 === 0">
                  <td class="col-index">{{ i + 1 }}</td>
                  <td class="col-name">{{ item.name | titlecase }}</td>
                  <td class="col-action">
                    <button
                      type="button"
                      class="ns-btn-delete"
                      (click)="deleteCitySel(item)"
                      title="Delete City">
                      <i class="fa fa-trash-o"></i>
                    </button>
                  </td>
                </tr>
                <tr *ngIf="citysel.length === 0 && !loadingCity">
                  <td colspan="3" class="ns-status-cell ns-status-cell--empty">
                    <i class="fa fa-folder-open-o"></i> No cities registered yet
                  </td>
                </tr>
                <tr *ngIf="loadingCity">
                  <td colspan="3" class="ns-status-cell">
                    <i class="fa fa-spinner fa-spin"></i> Loading cities...
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- ==========================================
         SECTION 2: SERVICES & OPERATIONS
         ========================================== -->
    <div class="ns-section-divider">
      <i class="fa fa-cogs"></i>
      <span>Services & Operations</span>
    </div>

    <!-- 2.1 BUSINESS TYPES -->
    <div class="ns-accordion-item" [class.ns-accordion-item--expanded]="isExpanded('businessTypes')">
      <div class="ns-accordion-header" (click)="toggleSection('businessTypes')">
        <div class="ns-accordion-header__title-group">
          <span class="ns-accordion-header__title">Business Types</span>
          <span class="ns-count-badge">{{ businessTypessel.length }}</span>
        </div>
        <i class="fa fa-chevron-down ns-accordion-header__arrow"
           [class.ns-accordion-header__arrow--expanded]="isExpanded('businessTypes')"></i>
      </div>

      <div class="ns-accordion-body" [class.ns-accordion-body--expanded]="isExpanded('businessTypes')">
        <div class="ns-accordion-content">
          <!-- Form -->
          <div class="ns-form-wrapper">
            <form [formGroup]="businessTypeSelForm" (ngSubmit)="newBusinessTypeSel()" autocomplete="off">
              <div class="ns-input-row">
                <div class="ns-input-container">
                  <input
                    type="text"
                    class="ns-input"
                    placeholder="Enter new business type..."
                    formControlName="name"
                    [class.is-invalid]="businessTypeNameNoValido"
                    toUppercase
                  />
                </div>
                <button type="submit" class="ns-btn-primary" [disabled]="loadingBusinessType || businessTypeSelForm.invalid">
                  <i class="fa fa-plus"></i> Add Type
                </button>
              </div>
              <small *ngIf="businessTypeNameNoValido" class="ns-error-msg">* Required</small>
            </form>
          </div>

          <!-- Table -->
          <div class="ns-table-wrapper">
            <table class="ns-table">
              <thead>
                <tr>
                  <th class="col-index">#</th>
                  <th>Business Type</th>
                  <th class="col-action">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of businessTypessel; let i = index" [class.row-alt]="i % 2 === 0">
                  <td class="col-index">{{ i + 1 }}</td>
                  <td class="col-name">{{ item.name | titlecase }}</td>
                  <td class="col-action">
                    <button
                      type="button"
                      class="ns-btn-delete"
                      (click)="deleteBusinessTypeSel(item)"
                      title="Delete Business Type">
                      <i class="fa fa-trash-o"></i>
                    </button>
                  </td>
                </tr>
                <tr *ngIf="businessTypessel.length === 0 && !loadingBusinessType">
                  <td colspan="3" class="ns-status-cell ns-status-cell--empty">
                    <i class="fa fa-folder-open-o"></i> No business types registered yet
                  </td>
                </tr>
                <tr *ngIf="loadingBusinessType">
                  <td colspan="3" class="ns-status-cell">
                    <i class="fa fa-spinner fa-spin"></i> Loading business types...
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- 2.2 WORK REQUESTS -->
    <div class="ns-accordion-item" [class.ns-accordion-item--expanded]="isExpanded('workRequests')">
      <div class="ns-accordion-header" (click)="toggleSection('workRequests')">
        <div class="ns-accordion-header__title-group">
          <span class="ns-accordion-header__title">Work Requests</span>
          <span class="ns-count-badge">{{ workreqsel.length }}</span>
        </div>
        <i class="fa fa-chevron-down ns-accordion-header__arrow"
           [class.ns-accordion-header__arrow--expanded]="isExpanded('workRequests')"></i>
      </div>

      <div class="ns-accordion-body" [class.ns-accordion-body--expanded]="isExpanded('workRequests')">
        <div class="ns-accordion-content">
          <!-- Form -->
          <div class="ns-form-wrapper">
            <form [formGroup]="workReqSelForm" (ngSubmit)="newWorkReqSel()" autocomplete="off">
              <div class="ns-input-row">
                <div class="ns-input-container">
                  <input
                    type="text"
                    class="ns-input"
                    placeholder="Enter new work request..."
                    formControlName="name"
                    [class.is-invalid]="workReqNameNoValido"
                    toUppercase
                  />
                </div>
                <button type="submit" class="ns-btn-primary" [disabled]="loadingWorkreq || workReqSelForm.invalid">
                  <i class="fa fa-plus"></i> Add Request
                </button>
              </div>
              <small *ngIf="workReqNameNoValido" class="ns-error-msg">* Required</small>
            </form>
          </div>

          <!-- Table -->
          <div class="ns-table-wrapper">
            <table class="ns-table">
              <thead>
                <tr>
                  <th class="col-index">#</th>
                  <th>Work Request</th>
                  <th class="col-action">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of workreqsel; let i = index" [class.row-alt]="i % 2 === 0">
                  <td class="col-index">{{ i + 1 }}</td>
                  <td class="col-name">{{ item.name | titlecase }}</td>
                  <td class="col-action">
                    <button
                      type="button"
                      class="ns-btn-delete"
                      (click)="deleteWorkReqSel(item)"
                      title="Delete Work Request">
                      <i class="fa fa-trash-o"></i>
                    </button>
                  </td>
                </tr>
                <tr *ngIf="workreqsel.length === 0 && !loadingWorkreq">
                  <td colspan="3" class="ns-status-cell ns-status-cell--empty">
                    <i class="fa fa-folder-open-o"></i> No work requests registered yet
                  </td>
                </tr>
                <tr *ngIf="loadingWorkreq">
                  <td colspan="3" class="ns-status-cell">
                    <i class="fa fa-spinner fa-spin"></i> Loading work requests...
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- 2.3 REQUESTER ROLES -->
    <div class="ns-accordion-item" [class.ns-accordion-item--expanded]="isExpanded('requesterRoles')">
      <div class="ns-accordion-header" (click)="toggleSection('requesterRoles')">
        <div class="ns-accordion-header__title-group">
          <span class="ns-accordion-header__title">Requester Roles</span>
          <span class="ns-count-badge">{{ requesterRolessel.length }}</span>
        </div>
        <i class="fa fa-chevron-down ns-accordion-header__arrow"
           [class.ns-accordion-header__arrow--expanded]="isExpanded('requesterRoles')"></i>
      </div>

      <div class="ns-accordion-body" [class.ns-accordion-body--expanded]="isExpanded('requesterRoles')">
        <div class="ns-accordion-content">
          <!-- Form -->
          <div class="ns-form-wrapper">
            <form [formGroup]="requesterRoleSelForm" (ngSubmit)="newRequesterRoleSel()" autocomplete="off">
              <div class="ns-input-row">
                <div class="ns-input-container">
                  <input
                    type="text"
                    class="ns-input"
                    placeholder="Enter new requester role..."
                    formControlName="name"
                    [class.is-invalid]="requesterRoleNameNoValido"
                    toUppercase
                  />
                </div>
                <button type="submit" class="ns-btn-primary" [disabled]="loadingRequesterRole || requesterRoleSelForm.invalid">
                  <i class="fa fa-plus"></i> Add Role
                </button>
              </div>
              <small *ngIf="requesterRoleNameNoValido" class="ns-error-msg">* Required</small>
            </form>
          </div>

          <!-- Table -->
          <div class="ns-table-wrapper">
            <table class="ns-table">
              <thead>
                <tr>
                  <th class="col-index">#</th>
                  <th>Role Name</th>
                  <th class="col-action">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of requesterRolessel; let i = index" [class.row-alt]="i % 2 === 0">
                  <td class="col-index">{{ i + 1 }}</td>
                  <td class="col-name">{{ item.name | titlecase }}</td>
                  <td class="col-action">
                    <button
                      type="button"
                      class="ns-btn-delete"
                      (click)="deleteRequesterRoleSel(item)"
                      title="Delete Requester Role">
                      <i class="fa fa-trash-o"></i>
                    </button>
                  </td>
                </tr>
                <tr *ngIf="requesterRolessel.length === 0 && !loadingRequesterRole">
                  <td colspan="3" class="ns-status-cell ns-status-cell--empty">
                    <i class="fa fa-folder-open-o"></i> No requester roles registered yet
                  </td>
                </tr>
                <tr *ngIf="loadingRequesterRole">
                  <td colspan="3" class="ns-status-cell">
                    <i class="fa fa-spinner fa-spin"></i> Loading requester roles...
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- 2.4 TANK SIZES -->
    <div class="ns-accordion-item" [class.ns-accordion-item--expanded]="isExpanded('tankSizes')">
      <div class="ns-accordion-header" (click)="toggleSection('tankSizes')">
        <div class="ns-accordion-header__title-group">
          <span class="ns-accordion-header__title">Tank Sizes</span>
          <span class="ns-count-badge">{{ tankSizessel.length }}</span>
        </div>
        <i class="fa fa-chevron-down ns-accordion-header__arrow"
           [class.ns-accordion-header__arrow--expanded]="isExpanded('tankSizes')"></i>
      </div>

      <div class="ns-accordion-body" [class.ns-accordion-body--expanded]="isExpanded('tankSizes')">
        <div class="ns-accordion-content">
          <!-- Form -->
          <div class="ns-form-wrapper">
            <form [formGroup]="tankSizeSelForm" (ngSubmit)="newTankSizeSel()" autocomplete="off">
              <div class="ns-input-row">
                <div class="ns-input-container">
                  <input
                    type="text"
                    class="ns-input"
                    placeholder="Enter new tank size (e.g. 200)..."
                    formControlName="name"
                    [class.is-invalid]="tankSizeNameNoValido"
                  />
                </div>
                <button type="submit" class="ns-btn-primary" [disabled]="loadingTankSize || tankSizeSelForm.invalid">
                  <i class="fa fa-plus"></i> Add Tank Size
                </button>
              </div>
              <small *ngIf="tankSizeNameNoValido" class="ns-error-msg">* Required</small>
            </form>
          </div>

          <!-- Table -->
          <div class="ns-table-wrapper">
            <table class="ns-table">
              <thead>
                <tr>
                  <th class="col-index">#</th>
                  <th>Tank Size</th>
                  <th class="col-action">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of tankSizessel; let i = index" [class.row-alt]="i % 2 === 0">
                  <td class="col-index">{{ i + 1 }}</td>
                  <td class="col-name">{{ item.name }}</td>
                  <td class="col-action">
                    <button
                      type="button"
                      class="ns-btn-delete"
                      (click)="deleteTankSizeSel(item)"
                      title="Delete Tank Size">
                      <i class="fa fa-trash-o"></i>
                    </button>
                  </td>
                </tr>
                <tr *ngIf="tankSizessel.length === 0 && !loadingTankSize">
                  <td colspan="3" class="ns-status-cell ns-status-cell--empty">
                    <i class="fa fa-folder-open-o"></i> No tank sizes registered yet
                  </td>
                </tr>
                <tr *ngIf="loadingTankSize">
                  <td colspan="3" class="ns-status-cell">
                    <i class="fa fa-spinner fa-spin"></i> Loading tank sizes...
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

  </div>

</div>